export default __webpack_public_path__ + "static/media/linearbg.940f9423.png";